import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Checkbox } from "@/components/ui/checkbox";
import ComuneAutocomplete from "@/components/common/ComuneAutocomplete";

const RISCHI_AZIENDE = [
  "RC verso terzi", "RC Professionale", "D&O", "Cyber Risk",
  "Incendio locali", "Furto", "Tutela legale"
];

export function AziendeStep0({ formData, update }) {
  return (
    <div className="space-y-5">
      <div className="space-y-2">
        <Label className="text-sm text-[#0F1F14]">Ragione sociale</Label>
        <Input value={formData.ragione_sociale || ""} onChange={e => update("ragione_sociale", e.target.value)} className="rounded-xl border-[#E5E2DB] h-11 focus:ring-2 focus:ring-[#163321]/20 focus:border-[#163321]" placeholder="Nome dell'azienda" data-testid="ragione-sociale-input" />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label className="text-sm text-[#0F1F14]">Codice Fiscale o Partita IVA</Label>
          <Input value={formData.cf_piva || ""} onChange={e => update("cf_piva", e.target.value.toUpperCase())} className="rounded-xl border-[#E5E2DB] h-11 focus:ring-2 focus:ring-[#163321]/20 focus:border-[#163321]" placeholder="es. 01234567890" data-testid="cf-piva-input" />
        </div>
        <div className="space-y-2">
          <Label className="text-sm text-[#0F1F14]">Codice ATECO</Label>
          <Input value={formData.codice_ateco || ""} onChange={e => update("codice_ateco", e.target.value)} className="rounded-xl border-[#E5E2DB] h-11 focus:ring-2 focus:ring-[#163321]/20 focus:border-[#163321]" placeholder="es. 62.01" data-testid="codice-ateco-input" />
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label className="text-sm text-[#0F1F14]">Numero dipendenti</Label>
          <Select value={formData.num_dipendenti || ""} onValueChange={v => update("num_dipendenti", v)}>
            <SelectTrigger className="rounded-xl border-[#E5E2DB] h-11" data-testid="num-dipendenti-select"><SelectValue placeholder="Seleziona" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="1">Solo io</SelectItem>
              <SelectItem value="2-5">2-5</SelectItem>
              <SelectItem value="6-20">6-20</SelectItem>
              <SelectItem value="21-50">21-50</SelectItem>
              <SelectItem value="50+">Più di 50</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-2">
          <Label className="text-sm text-[#0F1F14]">Settore</Label>
          <Input value={formData.settore || ""} onChange={e => update("settore", e.target.value)} className="rounded-xl border-[#E5E2DB] h-11 focus:ring-2 focus:ring-[#163321]/20 focus:border-[#163321]" placeholder="es. Tecnologia" data-testid="settore-input" />
        </div>
      </div>
    </div>
  );
}

export function AziendeStep1({ formData, update, toggleArray }) {
  return (
    <div className="space-y-5">
      <div className="space-y-2">
        <Label className="text-sm text-[#0F1F14]">Fatturato annuo</Label>
        <Select value={formData.fatturato_annuo || ""} onValueChange={v => update("fatturato_annuo", v)}>
          <SelectTrigger className="rounded-xl border-[#E5E2DB] h-11" data-testid="fatturato-select"><SelectValue placeholder="Seleziona fascia" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="sotto_100k">Sotto 100.000 €</SelectItem>
            <SelectItem value="100k_500k">100.000 - 500.000 €</SelectItem>
            <SelectItem value="500k_1m">500.000 - 1.000.000 €</SelectItem>
            <SelectItem value="1m_5m">1.000.000 - 5.000.000 €</SelectItem>
            <SelectItem value="sopra_5m">Sopra 5.000.000 €</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <p className="text-sm text-[#4A5E51]">Seleziona i rischi di tuo interesse:</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {RISCHI_AZIENDE.map(r => (
          <label key={r} className={`flex items-center gap-3 p-4 rounded-xl border cursor-pointer transition-all ${(formData.rischi_aziendali || []).includes(r) ? 'border-[#163321] bg-[#163321]/5' : 'border-[#E5E2DB] hover:bg-[#F5F4F0]'}`} data-testid={`rischio-az-${r.replace(/\s/g, '-').toLowerCase()}`}>
            <Checkbox checked={(formData.rischi_aziendali || []).includes(r)} onCheckedChange={() => toggleArray("rischi_aziendali", r)} className="data-[state=checked]:bg-[#163321]" />
            <span className="text-sm text-[#0F1F14]">{r}</span>
          </label>
        ))}
      </div>
      <div className="space-y-2">
        <Label className="text-sm text-[#0F1F14]">Esigenze specifiche</Label>
        <Textarea value={formData.esigenze_specifiche || ""} onChange={e => update("esigenze_specifiche", e.target.value)} className="rounded-xl border-[#E5E2DB] focus:ring-2 focus:ring-[#163321]/20 focus:border-[#163321] min-h-[80px]" placeholder="Descrivi le tue esigenze specifiche..." data-testid="esigenze-textarea" />
      </div>
    </div>
  );
}

export function renderAziendeStep(step, formData, update, toggleArray) {
  if (step === 0) return <AziendeStep0 formData={formData} update={update} />;
  if (step === 1) return <AziendeStep1 formData={formData} update={update} toggleArray={toggleArray} />;
  if (step === 2) return <AziendeStep2_SedeOperativa formData={formData} update={update} />;
  return null;
}

/**
 * Task A (8 mag 2026) — Step "Sede operativa".
 * Tutti i campi sono OPZIONALI: se vuoti, il calcolo silente VRS skippa
 * con outcome=skipped. L'admin vede comunque la submission completa.
 */
export function AziendeStep2_SedeOperativa({ formData, update }) {
  // sede_operativa è un sub-oggetto; aggiorniamo via merge
  const sede = formData.sede_operativa || {};
  const setSede = (key, val) => update("sede_operativa", { ...sede, [key]: val });

  return (
    <div className="space-y-5" data-testid="aziende-step-sede-operativa">
      <div className="bg-emerald-50/60 border border-emerald-200 rounded-xl p-3 text-[11px] text-emerald-900">
        ⓘ Questi dati sono <strong>facoltativi</strong>. Se compilati, il nostro back-office
        prepara una stima preliminare di valore di ricostruzione del fabbricato che useremo
        in fase di consulenza. Nessun importo viene mostrato qui al cliente.
      </div>

      <div className="space-y-2">
        <Label className="text-sm text-[#0F1F14]">Comune sede operativa</Label>
        <ComuneAutocomplete
          value={sede.comune || ""}
          onChange={(v) => {
            // Pattern usato dal componente: passa il nome del comune (string) o oggetto.
            if (typeof v === "string") {
              setSede("comune", v);
            } else if (v && typeof v === "object") {
              const next = { ...sede, comune: v.nome || v.label || "" };
              if (v.provincia) next.provincia = v.provincia;
              update("sede_operativa", next);
            } else {
              setSede("comune", "");
            }
          }}
          includeEsteri={false}
          placeholder="Cerca comune"
          data-testid="sede-comune-input"
        />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label className="text-sm text-[#0F1F14]">Provincia</Label>
          <Input
            value={sede.provincia || ""}
            onChange={(e) => setSede("provincia", e.target.value.toUpperCase().slice(0, 2))}
            placeholder="es. NA"
            maxLength={2}
            className="rounded-xl border-[#E5E2DB] h-11"
            data-testid="sede-provincia-input"
          />
        </div>
        <div className="space-y-2">
          <Label className="text-sm text-[#0F1F14]">Superficie utile (mq)</Label>
          <Input
            type="number"
            min={10}
            max={100000}
            step={1}
            value={sede.superficie_mq ?? ""}
            onChange={(e) => {
              const raw = e.target.value;
              setSede("superficie_mq", raw === "" ? "" : Number(raw));
            }}
            placeholder="es. 250"
            className="rounded-xl border-[#E5E2DB] h-11"
            data-testid="sede-mq-input"
          />
        </div>
      </div>

      <div className="space-y-2">
        <Label className="text-sm text-[#0F1F14]">Via, civico, CAP</Label>
        <Input
          value={sede.indirizzo || ""}
          onChange={(e) => setSede("indirizzo", e.target.value)}
          placeholder="es. Via Roma 12, 80055"
          className="rounded-xl border-[#E5E2DB] h-11"
          data-testid="sede-indirizzo-input"
        />
      </div>

      <div className="space-y-2">
        <Label className="text-sm text-[#0F1F14]">Tipologia immobile sede</Label>
        <Select
          value={sede.tipologia_immobile || ""}
          onValueChange={(v) => setSede("tipologia_immobile", v)}
        >
          <SelectTrigger className="rounded-xl border-[#E5E2DB] h-11" data-testid="sede-tipologia-select">
            <SelectValue placeholder="Seleziona (facoltativo)" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="ufficio">Ufficio</SelectItem>
            <SelectItem value="capannone">Capannone industriale</SelectItem>
            <SelectItem value="negozio">Negozio / retail</SelectItem>
            <SelectItem value="magazzino">Magazzino</SelectItem>
            <SelectItem value="centro_logistico">Centro logistico</SelectItem>
            <SelectItem value="altro">Altro</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
